<template>
  <div>
	<div class="mapBox">
		<div class="mapBoxOne">
			<!-- <img src="@/assets/about/dt.png" /> -->
			<aboutMapTwo ref="aboutMapTwo" :list="qqbj"></aboutMapTwo>
		</div>
		<div class="mapBoxTwo">
			<div class="mapBoxTwoFor" v-for="(item,index) in qqbj.tableData" :key="index" :class="qqbjXz==index?'mapBoxTwoForXz':''" @click="goClick(item,index)">
				{{item.city}}
			</div>
		</div>
	</div>
  </div>
</template>

<script>
	import aboutMapTwo from "./aboutMapTwo.vue"
  export default {
    components: {
		aboutMapTwo
    },
	props:{
		qqbj:{
			typeof:Object,
			default:{}
		}
	},
    data() {
      return {
		qqbjXz:0
      }
    },
    mounted() {

    },
    methods: {
		goClick(e,a){
			this.qqbjXz=a;
			let loc=e.location.split(',');
			loc.map(v=>{
				 v=Number(v);
				 return v
			});
			this.$nextTick(function(){
				console.log(loc)
				if(e.location){
					this.$refs.aboutMapTwo.location=loc;
				}
			})
		}
    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.mapBox{
	display: flex;
	// min-height: 100vh;
	// padding-bottom: 130px;
	.mapBoxOne{
		flex: 1;
		img{
			width: 100%;
			height: 860px;
			object-fit: contain;
		}
	}
	.mapBoxTwo{
		margin-left: 20px;
		display: none;
		position: relative;
		z-index: 999;
		.mapBoxTwoFor{
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #777;
			cursor: pointer;
			margin-bottom: 30px;
		}
		.mapBoxTwoForXz{
			color: #000000;
		}
	}
}
@media screen and (max-width:1200px) {
		.mapBox{
			width: 100% !important;
			overflow: hidden;
		}
	}
</style>
